import { useQuery } from '@tanstack/react-query';
import { getProductNotFamily } from 'services/api/requests/requests';

export const useProductNotFamilyList = () => {
	return useQuery(['productNotFamily-list'], getProductNotFamily, {
		refetchOnWindowFocus: false,
	});
};
